// extracted by mini-css-extract-plugin
export default {"block":"a3wIR","shadow":"b3wIR","sticked":"c3wIR","hidden":"d3wIR","positionTop":"e3wIR","positionBottom":"f3wIR"};